<ct-lib-modal
  #modal
  [big]="true"
  [hideFooter]="true"
  [label]="
    (context()?.mode === PlatformApplyWithProfileMode.FOLLOW_UP
      ? 'jobboard.platform.apply-with-profile.follow-up-title'
      : 'jobboard.platform.apply-with-profile.title'
    ) | transloco
  "
  (onClose)="applyService.close()"
>
  @if (context(); as current) {
    <form class="apply-form" [formGroup]="form" (ngSubmit)="submit()">
      <ct-lib-inline-info>
        <p>
          {{
            (current.mode === PlatformApplyWithProfileMode.FOLLOW_UP
              ? 'jobboard.platform.apply-with-profile.follow-up-intro'
              : 'jobboard.platform.apply-with-profile.intro'
            ) | transloco: { job: current.jobTitle, company: current.companyName }
          }}
        </p>
      </ct-lib-inline-info>

      <section class="section">
        <div class="section-header">
          <h5>{{ 'jobboard.platform.apply-with-profile.sections.contact' | transloco }}</h5>
          <a class="profile-link" [routerLink]="['/profile']" (click)="close()">
            {{ 'jobboard.platform.apply-with-profile.edit-profile' | transloco }}
          </a>
        </div>
        <dl class="facts">
          @if (profile.profile().firstName) {
            <div class="fact">
              <dt>{{ 'jobboard.platform.profile.sections.contact.first-name' | transloco }}</dt>
              <dd>{{ profile.profile().firstName }}</dd>
            </div>
          }
          @if (profile.profile().lastName) {
            <div class="fact">
              <dt>{{ 'jobboard.platform.profile.sections.contact.last-name' | transloco }}</dt>
              <dd>{{ profile.profile().lastName }}</dd>
            </div>
          }
          <div class="fact">
            <dt>{{ 'jobboard.platform.profile.sections.contact.email' | transloco }}</dt>
            <dd>{{ profile.profile().email }}</dd>
          </div>
          @if (profile.profile().phone) {
            <div class="fact">
              <dt>{{ 'jobboard.platform.profile.sections.contact.phone' | transloco }}</dt>
              <dd>{{ profile.profile().phone }}</dd>
            </div>
          }
          @if (profile.profile().city) {
            <div class="fact">
              <dt>{{ 'jobboard.platform.profile.sections.contact.city' | transloco }}</dt>
              <dd>{{ profile.profile().city }}</dd>
            </div>
          }
          @if (profile.profile().currentOccupation) {
            <div class="fact">
              <dt>{{ 'jobboard.platform.profile.sections.contact.occupation' | transloco }}</dt>
              <dd>{{ profile.profile().currentOccupation }}</dd>
            </div>
          }
        </dl>

        @if (showNameInputs()) {
          <div class="row">
            <div
              class="col-12 col-md-6 form-group form-floating"
              [class.invalid]="form.controls['firstName'].invalid && submitAttempt()"
            >
              <input
                type="text"
                class="form-control"
                formControlName="firstName"
                id="applyProfileFirstName"
                [placeholder]="'jobboard.platform.profile.sections.contact.first-name' | transloco"
              />
              <label for="applyProfileFirstName">{{
                'jobboard.platform.profile.sections.contact.first-name' | transloco
              }}</label>
            </div>
            <div
              class="col-12 col-md-6 form-group form-floating"
              [class.invalid]="form.controls['lastName'].invalid && submitAttempt()"
            >
              <input
                type="text"
                class="form-control"
                formControlName="lastName"
                id="applyProfileLastName"
                [placeholder]="'jobboard.platform.profile.sections.contact.last-name' | transloco"
              />
              <label for="applyProfileLastName">{{
                'jobboard.platform.profile.sections.contact.last-name' | transloco
              }}</label>
            </div>
          </div>
        }
        @if (showPhoneInput()) {
          <div
            class="form-group form-floating"
            [class.invalid]="form.controls['phone'].invalid && submitAttempt()"
          >
            <input
              type="tel"
              class="form-control"
              formControlName="phone"
              id="applyProfilePhone"
              [placeholder]="'jobboard.platform.profile.sections.contact.phone' | transloco"
            />
            <label for="applyProfilePhone">{{
              'jobboard.platform.profile.sections.contact.phone' | transloco
            }}</label>
          </div>
        }
        @if (showCityInput()) {
          <div class="form-group form-floating">
            <input
              type="text"
              class="form-control"
              formControlName="city"
              id="applyProfileCity"
              [placeholder]="'jobboard.platform.profile.sections.contact.city' | transloco"
            />
            <label for="applyProfileCity">{{
              'jobboard.platform.profile.sections.contact.city' | transloco
            }}</label>
          </div>
        }
      </section>

      @if (showCv() || showCoverLetter() || showCertificates() || certificateDocuments().length > 0 || coverLetterDocuments().length > 0) {
        <section class="section">
          <h5>{{ 'jobboard.platform.apply-with-profile.sections.documents' | transloco }}</h5>
          @if (showCv()) {
            <ct-lib-file-input
              [control]="cvControl()"
              [multiple]="false"
              [accept]="fileTypes"
              [showAcceptLabel]="false"
              [existingFileName]="mainCvName()"
              [replaceLabel]="'jobboard.platform.apply-with-profile.replace-cv' | transloco"
              [submitAttempt]="submitAttempt() && form.controls['cv'].invalid"
              [label]="'jobboard.platform.jobs.applications.complete-fields.cv' | transloco"
            ></ct-lib-file-input>
            <p class="hint text-muted">
              {{ 'jobboard.platform.apply-with-profile.cv-hint' | transloco }}
            </p>
          }
          @if (coverLetterDocuments().length > 0) {
            <div class="existing-files">
              <p class="existing-label">{{
                'jobboard.platform.apply-with-profile.existing-cover-letter' | transloco
              }}</p>
              @for (document of coverLetterDocuments(); track document.id) {
                <p class="file-name">{{ document.name }}</p>
              }
            </div>
          }
          @if (certificateDocuments().length > 0) {
            <div class="existing-files">
              <p class="existing-label">{{
                'jobboard.platform.apply-with-profile.existing-certificates' | transloco
              }}</p>
              @for (document of certificateDocuments(); track document.id) {
                <p class="file-name">{{ document.name }}</p>
              }
            </div>
          }
          @if (showCoverLetter()) {
            <ct-lib-file-input
              [control]="coverLetterControl()"
              [multiple]="false"
              [accept]="fileTypes"
              [showAcceptLabel]="false"
              [submitAttempt]="submitAttempt() && form.controls['coverLetter'].invalid"
              [label]="'jobboard.platform.apply-with-profile.cover-letter' | transloco"
            ></ct-lib-file-input>
          }
          @if (showCertificates()) {
            <ct-lib-file-input
              [control]="certificatesControl()"
              [multiple]="true"
              [accept]="fileTypes"
              [showAcceptLabel]="false"
              [submitAttempt]="submitAttempt() && form.controls['certificates'].invalid"
              [label]="'jobboard.platform.jobs.applications.complete-fields.certificates' | transloco"
            ></ct-lib-file-input>
          }
        </section>
      }

      <section class="section">
        <h5>{{ 'jobboard.platform.apply-with-profile.sections.skills' | transloco }}</h5>
        @if (skills().length === 0) {
          <p class="text-muted empty">{{
            'jobboard.platform.profile.sections.skills.empty' | transloco
          }}</p>
        } @else {
          <div class="skill-list">
            @for (skill of skills(); track skill.name) {
              <ct-lib-skill-level-tag
                [name]="skill.name"
                [levelLabel]="skillLevelLabel(skill.level)"
                [options]="skillLevelOptions"
                [selectedValue]="skill.level"
                [deletable]="false"
                (levelChange)="updateSkillLevel(skill.name, $event)"
              />
            }
          </div>
          <p class="hint text-muted">
            {{ 'jobboard.platform.apply-with-profile.missing-skills-hint' | transloco }}
          </p>
        }
      </section>

      @if (showStartDate() || showSalary()) {
        <section class="section">
          <h5>{{ 'jobboard.platform.apply-with-profile.sections.details' | transloco }}</h5>
          @if (showStartDate() && formNonce()) {
            <div
              class="form-group"
              [class.invalid]="form.controls['startDate'].invalid && submitAttempt()"
            >
              <app-date-input
                [control]="startDateControl()"
                [submitAttempt]="submitAttempt()"
                [placeholder]="
                  'jobboard.platform.jobs.applications.complete-fields.start-date' | transloco
                "
              ></app-date-input>
            </div>
          }
          @if (showSalary()) {
            <div
              class="form-group form-floating"
              [class.invalid]="form.controls['salary'].invalid && submitAttempt()"
            >
              <ct-lib-salary-input
                [control]="salaryControl()"
                currencyCode="EUR"
                [placeholder]="
                  'jobboard.platform.jobs.applications.complete-fields.salary' | transloco
                "
              ></ct-lib-salary-input>
            </div>
          }
        </section>
      }

      <section class="section">
        <h5>{{ 'jobboard.platform.apply-with-profile.sections.privacy' | transloco }}</h5>
        <div
          class="form-group terms"
          [class.invalid]="form.controls['privacyAccepted'].invalid && submitAttempt()"
        >
          <input type="checkbox" id="applyProfilePrivacy" formControlName="privacyAccepted" />
          <label for="applyProfilePrivacy">
            {{ 'jobboard.views.apply.sections.finish.agb-1' | transloco }}
            <a href="https://catch.hr/tos-applicants" target="_blank" rel="noopener noreferrer">{{
              'jobboard.views.apply.sections.finish.agb-2' | transloco
            }}</a>
            {{ 'jobboard.views.apply.sections.finish.agb-3' | transloco }}
            @if (privacyExpanded()) {
              <p [innerHTML]="'jobboard.views.apply.sections.finish.agb-4' | transloco"></p>
            }
            <button type="button" class="toggle-privacy" (click)="togglePrivacy()">
              {{
                (privacyExpanded()
                  ? 'jobboard.views.apply.sections.finish.checkboxes.show-less'
                  : 'jobboard.views.apply.sections.finish.checkboxes.show-more'
                ) | transloco
              }}
            </button>
          </label>
        </div>
      </section>

      <div class="footer-actions">
        @if (current.manualApplyUrl) {
          <app-button
            variant="white-grey"
            htmlType="button"
            [routerLink]="current.manualApplyUrl"
            (click)="close()"
          >
            {{ 'jobboard.platform.apply-with-profile.manual-cta' | transloco }}
          </app-button>
        }
        <app-button variant="primary" htmlType="submit">
          {{
            (current.mode === PlatformApplyWithProfileMode.FOLLOW_UP
              ? 'jobboard.platform.apply-with-profile.follow-up-submit'
              : 'jobboard.platform.apply-with-profile.submit'
            ) | transloco
          }}
        </app-button>
      </div>
    </form>
  }
</ct-lib-modal>
